import { cn } from "@/lib/utils"
import { Spinner } from "./spinner/Spinner"

interface LoadingProps {
  className?: string
  size?: "sm" | "md" | "lg" | "xl"
  fullScreen?: boolean
  text?: string
}

export function Loading({ className, fullScreen = false, text }: LoadingProps) {
  const content = (
    <div className={cn("flex flex-col items-center justify-center gap-2", className)}>
      <Spinner />
      {text && <span className="text-sm text-muted-foreground">{text}</span>}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm z-50">
        {content}
      </div>
    )
  }

  return content
}
